import { EInputMode, TInputModeOption } from '../types';

export const ADDRESS_CADASTRAL_FIELD_TEST_ID = 'addressCadastreField';

export const ADDRESS_SUGGEST_PLACEHOLDER = 'Населенный пункт, улица, дом';
export const ADDRESS_SUGGEST_NOT_FOUND_TEXT = 'Укажите другой адрес';
export const ADDRESS_SUGGEST_MIN_SEARCH_LENGTH = 3;

export const CADASTRE_INPUT_PLACEHOLDER = 'Кадастровый номер';
export const CADASTRE_INPUT_VALUE_REGEXP = /^\d{2}:\d{2}:\d{5,7}:\d+$/;

export const ADDRESS_CADASTRE_VALIDATION_ERRORS = {
  emptyValue: 'Укажите адрес или кадастровый номер',
  cadastreFormat: 'Укажите кадастровый номер в формате 31:XX:XXXXXXX:X',
};

export const ADDRESS_INPUT_MODE_LABEL = 'Адрес объекта';
export const CADASTRE_INPUT_MODE_LABEL = 'Кадастровый номер';

export const INPUT_MODE_OPTIONS: TInputModeOption[] = [
  {
    value: EInputMode.Address,
    label: ADDRESS_INPUT_MODE_LABEL,
  },
  {
    value: EInputMode.Cadastre,
    label: CADASTRE_INPUT_MODE_LABEL,
  },
];

export const ADDRESS_NOT_FOUND_ALERT = {
  title: 'Не нашли такой адрес в Росреестре',
  message: 'Проверьте адрес или попробуйте найти объект по кадастровому номеру',
  testId: 'addressNotFoundError',
};

export const CADASTRE_NOT_FOUND_ALERT = {
  title: 'Не нашли такой кадастровый номер в Росреестре',
  message: 'Проверьте кадастровый номер или попробуйте найти объект по адресу',
  testId: 'cadastreNotFoundError',
};

export const ADDRESS_HAS_MANY_CADASTRE_ALERT = {
  title: 'Этому адресу соответствует несколько кадастровых номеров',
  actionText: 'Укажите',
  actionTestId: 'addressHasManyCadastreErrorAction',
  message: ' кадастровый номер вручную',
  testId: 'addressHasManyCadastreError',
};
